import { observable, computed, action } from 'mobx';
import { TransactionApi } from '~api/TransactionApi';
import { Config } from '~domain/entities/Config';
import { Transaction } from '~domain/entities/Transaction';
import { DeliveryOptions, DeliveryMethods } from '../../constants/constants';

export class TransactionRepository {
    @observable transaction: Transaction;

    private api: TransactionApi;

    private deliveryOption: DeliveryOptions;

    @observable public configService: Config;

    constructor(config: Config, api: TransactionApi) {
        this.configService = config;
        this.api = api;
        this.transaction = new Transaction();
    }

    public loadTransaction = async () => {
        const transaction = await this.api.loadTransaction();
        const transactionValue = transaction[0].result?.value;
        this.transaction.setDeliveryOption(
            transactionValue?.order?.SHIP_METHOD || DeliveryOptions.STANDARD
        );
        this.transaction.setTransaction(transactionValue);

        return this.transaction;
    };

    @action
    setDeliveryOption = (deliveryOption: DeliveryOptions): void => {
        this.deliveryOption = deliveryOption;
    };

    @computed
    get getDeliveryMethod(): DeliveryMethods {
        switch (this.deliveryOption) {
            case DeliveryOptions.COURIER:
                return DeliveryMethods.COURIER;
            case DeliveryOptions.BOPIS:
                return DeliveryMethods.BOPIS;
            default:
                return DeliveryMethods.STANDARD;
        }
    }
}
